import React from 'react';
import './RxInput.scss';

import { Icon } from '../ui';

interface props {
  id: any;
  min: number;
  max: number;
  increment: number;
  defaultValue?: any;
  placeholder?: string;
  hasSign?: boolean;
  disabled?: boolean;
  changed: (e: any) => void;
}

const RxInput: React.FC<props> = ({
  id,
  min,
  max,
  increment,
  placeholder,
  defaultValue = '',
  hasSign = true,
  disabled = false,
  changed,
}) => {
  const renderOptions = () => {
    let start = min;
    let options: any[] = [];

    if (placeholder) {
      options = [...options, <option value="">{placeholder}</option>];
    }

    do {
      let value = start;
      options = [
        ...options,
        <option value={value} selected={defaultValue === value}>
          {hasSign && value > 0
            ? '+' + (increment != 1 ? value.toFixed(2) : value)
            : increment != 1
            ? value.toFixed(2)
            : value}
        </option>,
      ];

      start += increment;
    } while (start <= max);
    return options;
  };

  return (
    <div className="rx-input">
      <select id={id} name={id} disabled={disabled} className="rx-select" onChange={changed}>
        {renderOptions()}
      </select>
      <Icon imgPath="/images/icons/form-select-arrow.png" />
    </div>
  );
};

export default RxInput;
